export default "__VITE_ASSET__CmKpKZ_l__"